import React, {useEffect, useState} from "react";
import ReactDOM from 'react-dom';
import axios from 'axios';
import './ListaPOI.css';
import './StiliComuni.css'
import CardPOI from "./CardPOI";


class ListaPOI extends React.Component 
{
    constructor(props) {
        super(props);  
        this.state=
        {
            Token:this.props.Token,
            IDGame:this.props.IDGame,
            poi:[]
        }
        this.ModificaPOI = this.ModificaPOI.bind(this);
      }


    ModificaPOI(msg)
    {
        var ParametriRichiesta = new Object();
        ParametriRichiesta.token = this.state.Token;
        ParametriRichiesta.idgame = this.state.IDGame;

        axios.post('https://play.airsoftdigital.com/api/poistatus.php', JSON.stringify(ParametriRichiesta)).then(response => {
            if (response.data.status === "OK") {

                this.setState(prevState => ({
                    poi:response.data.poi,
                    Token: prevState.Token,
                    IDGame:prevState.IDGame}));
            } else {
                alert("Problemi di connessione. Impossibile recuperare l'elenco dei punti di interesse.")
            }
        });
    }


    componentDidMount()
    {
        var ParametriRichiesta = new Object();
        ParametriRichiesta.token = this.state.Token;
        ParametriRichiesta.idgame = this.state.IDGame;

        axios.post('https://play.airsoftdigital.com/api/poistatus.php', JSON.stringify(ParametriRichiesta)).then(response => {
            if (response.data.status === "OK") {

                this.setState(prevState => ({
                    poi:response.data.poi,
                    Token: prevState.Token,
                    IDGame:prevState.IDGame}));
            } else {
                alert("Problemi di connessione. Impossibile recuperare l'elenco dei punti di interesse.")
            }
        });
    }

    render()
    {
        
        
        var POI = this.state.poi;
        const ListaPOIAssociati = POI.map((currStation) =>
        
        <CardPOI callbackModificaPOI={this.ModificaPOI} IDGame={this.state.IDGame} Token={this.state.Token} id={currStation.id} nome={currStation.nome} seriale={currStation.serial} attiva={currStation.isActive} icona={currStation.icon} latitudine={currStation.latitudine} longitudine={currStation.longitudine} ultimoUpdate={currStation.lastupdate} utm_zone={currStation.utm_zone} utm_east={currStation.utm_east} utm_north={currStation.utm_north}/>
        );
        
       return <div>
        {ListaPOIAssociati}
        <div style={{height:70}}></div>
       </div>
    };
}


export default ListaPOI;